import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import WithRender from "@/Pages/Admin/Modules/Hotel/tab/Amenity/Views/hotel-amenity.html";
import GeneralModule from "@/Pages/Admin/Modules/ManagePackage/Store/General";
import { trekService } from "@/Pages/Admin/Modules/ManagePackage/Services/Trekservice";
import { common } from "@/Pages/Admin/Modules/Common/Services/Common";
import ValidationError from "@/Pages/Admin/Modules/Common/Controllers/ValidationError";
import { flashService } from "@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService";
import { HotelAmenityModel } from "@/Pages/Admin/Modules/Models/Hotel/HotelAmenityModel";
import { hotelService } from "@/Pages/Admin/Modules/Hotel/Services/HotelService";
import { AmenityModel } from "@/Pages/Admin/Modules/Models/Hotel/AmenityModel";
import { HotelAmenityServiceModel } from "@/Pages/Admin/Modules/Models/Hotel/HotelAmenityServiceModel";
@WithRender
@Component({
  components: {
    "validation-error": ValidationError,
  },
})
export default class HotelAmenity extends Vue {
  protected ui: any = {};
  protected item: any = {};
  protected addData: any = {};
  protected editData: any = {};

  constructor() {
    super();

    this.ui = {
      index: {
        edit: -1,
        delete: -1,
        up: 0,
        down: 0,
      },
      status: {
        isLoading: {
          getHotelAmenityList: false,
          amenityList: false,
        },
        postLoading: {
          create: false,
          edit: false,
          delete: false,
        },
        canAdd: false,
        canEdit: false,
      },
      error: {
        errors: {},
        has_error: false,
        error_message: {},
        modal: {
          delete: {},
        },
      },
    };

    this.item = {
      hotelAmenityList: new HotelAmenityModel({}),
      addHotelAmenity: new HotelAmenityModel({}),
      editHotelAmenity: new HotelAmenityModel({}),
      deleteHotelAmenity: new HotelAmenityModel({}),
      deleteHotelAmenityService: new HotelAmenityServiceModel({}),
      tempHotelAmenity: new HotelAmenityModel({}),
      amenityList: new AmenityModel({}),
    };
    this.addData = [{ title: "" }];
    this.editData = [];
  }

  public mounted() {
    this.getHotelAmenityList();
    this.getAmenityList();
  }

  get getAllIconsList() {
    return GeneralModule.Icons;
  }

  public getHotelAmenityList() {
    let data = {
      hotel_id: this.$route.query.id,
    };
    this.ui.status.isLoading.getHotelAmenityList = true;
    hotelService
      .allHotelAmenity(data)
      .then((res: any) => {
        res.data.data.filter((list: any) => {
          list.IsActive = false;
        });
        this.item.hotelAmenityList = res.data.data;
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.ui.error.errors).then((res: any) => {
          this.ui.error.has_error = true;
          this.ui.error.errors = res;
        });
      })
      .finally(() => {
        this.ui.status.isLoading.getHotelAmenityList = false;
      });
  }

  public getAmenityList() {
    this.ui.status.isLoading.amenityList = true;
    hotelService
      .amenityList()
      .then((res: any) => {
        this.item.amenityList = res.data.data;
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.ui.error.error_message).then((res) => {
          this.ui.error.has_error = true;
          this.ui.error.error_message = res;
        });
      })
      .finally(() => {
        this.ui.status.isLoading.amenityList = false;
      });
  }

  protected addHotelAmenity() {
    this.resetError();

    // if (!this.validateAddIncludeAction()) {
    //     return;
    // }

    const serviceTitle: Array<string> = [];
    const arrayServiceTitle: any = this.addData;
    arrayServiceTitle.forEach((item: any) => {
      serviceTitle.push(item.title);
    });

    let data = {
      hotel_id: this.$route.query.id,
      amenity_id: this.item.hotelAmenityList.amenity
        ? this.item.hotelAmenityList.amenity.id
        : "",
      title: serviceTitle,
    };
    this.ui.status.postLoading.create = true;
    hotelService
      .addHotelAmenity(data)
      .then((res: any) => {
        this.item.hotelAmenityList.unshift(res.data.data);
        flashService.Success("Amenity Added", res.data.message);
        this.ui.status.canAdd = false;
        this.item.addHotelAmenity = new HotelAmenityModel({});
        this.resetError();
        this.editData = [];
        this.addData = [];
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.ui.error.error_message).then((res) => {
          this.ui.error.error_message = res;
        });
      })
      .finally(() => {
        this.ui.status.postLoading.create = false;
      });
  }

  protected validateAddIncludeAction() {
    let list = this.item.addHotelAmenity;
    console.log(list);
    if (!list.title) {
      Object.assign(this.ui.error.errors, {
        title: ["The title field is required."],
      });
    }
    if (list.icon === null || list.icon.id === 0) {
      Object.assign(this.ui.error.errors, {
        icon_id: ["The icon field is required."],
      });
    }
    if (common.notEmpty(this.ui.error.errors)) {
      this.ui.error.has_error = true;
      return false;
    } else {
      return true;
    }
  }

  protected onEditHotelAmenityClick(index: number, list: any) {
    this.resetError();
    this.ui.status.canEdit = true;
    this.item.tempHotelAmenity = Object.assign({}, list);
    this.ui.index.edit = index;
    list.IsActive = true;
    this.item.editHotelAmenity = list;
    this.item.editData = list.amenity_service;
  }

  protected editHotelAmenity() {
    this.resetError();

    // if (!this.validateEditIncludeAction()) {
    //   return;
    // }
    const serviceTitle: Array<string> = [];
    const arrayServiceTitle: any = this.addData;
    arrayServiceTitle.forEach((item: any) => {
      serviceTitle.push(item.title);
    });
    let data = {
      hotel_id: this.$route.query.id,
      id: this.item.editHotelAmenity.id,
      amenity_id: this.item.editHotelAmenity.amenity.id,
      title: serviceTitle,
      editTitle: this.item.editData,
    };
    this.ui.status.postLoading.edit = true;
    hotelService
      .editHotelAmenity(data)
      .then((res: any) => {
        this.ui.status.canEdit = false;
        this.$set(
          this.item.hotelAmenityList,
          this.ui.index.edit,
          res.data.data
        );
        flashService.Success("Amenity Edited", res.data.message);

        this.resetError();
        this.addData = [];
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.ui.error.error_message).then((res) => {
          this.ui.error.error_message = res;
        });
      })
      .finally(() => {
        this.ui.status.canEdit = false;
        this.ui.status.postLoading.edit = false;
      });
  }

  protected validateEditIncludeAction() {
    let list = this.item.editInclude;
    if (!list.title) {
      Object.assign(this.ui.error.errors, {
        edit_title: ["The title field is required."],
      });
    }
    if (list.icon === null || list.icon.id === 0) {
      Object.assign(this.ui.error.errors, {
        edit_icon_id: ["The icon field is required."],
      });
    }
    if (common.notEmpty(this.ui.error.errors)) {
      this.ui.error.has_error = true;
      return false;
    } else {
      return true;
    }
  }

  protected cancelHotelAmenity(index: number, list: any) {
    this.resetError();
    this.ui.status.canEdit = false;
    list.IsActive = false;
    this.ui.index.edit = index;
    this.item.hotelAmenityList[index] = this.item.tempHotelAmenity;
  }

  protected onDeleteHotelAmenityClick(index: any, list: any) {
    this.resetError();
    this.ui.status.canEdit = false;
    $("#deleteSelectedHotelAmenity").modal("show");
    this.ui.index.delete = index;
    this.item.deleteHotelAmenity = list;
  }

  protected onRemoveServiceClick(index: any, service: any) {
    this.resetError();
    this.ui.status.canEdit = false;
    this.ui.index.delete = index;
    this.item.deleteHotelAmenityService = service;
  }

  protected deleteHotelAmenity() {
    this.resetError();
    let data = {
      hotel_id: this.$route.query.id,
      id: this.item.deleteHotelAmenity.id,
    };
    this.ui.status.postLoading.delete = true;
    hotelService
      .deleteHotelAmenity(data)
      .then((res: any) => {
        this.$delete(this.item.hotelAmenityList, this.ui.index.delete);
        flashService.Success("Amenity Deleted", res.data.message);
        this.hideDeleteModal();
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.ui.error.modal.delete).then((res) => {
          this.ui.error.modal.delete = res;
        });
      })
      .finally(() => {
        this.ui.status.postLoading.delete = false;
      });
  }

  protected removeService(index: number, service: any, editService: any) {
    this.resetError();
    editService.splice(index, 1);

    let data = {
      hotel_id: this.$route.query.id,
      id: service.id,
    };
    this.ui.status.postLoading.delete = true;
    hotelService
      .removeHotelAmenityservice(data)
      .then((res: any) => {
        flashService.Success("Service Deleted", res.data.message);
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.ui.error.modal.delete).then((res) => {
          this.ui.error.modal.delete = res;
        });
      })
      .finally(() => {
        this.ui.status.postLoading.delete = false;
      });
  }

  protected hideDeleteModal() {
    $("#deleteSelectedHotelAmenity").modal("hide");
    $(".modal-backdrop").remove();
    this.ui.error.modal.delete = {};
    this.resetError();
  }

  public resetError() {
    this.ui.error.errors = {};
    this.ui.error.has_error = false;
    this.ui.error.error_message = {};
  }

  public customLabel(name: any) {
    return name;
  }

  public get buttonTextAddHotelAmenity() {
    if (this.ui.status.postLoading.create) {
      return "Processing...";
    }
    return "Save Amenity";
  }

  protected showAddHotelAmenityButton() {
    this.ui.status.canAdd = true;
  }

  protected addNewService() {
    this.addData.push({
      title: "",
    });
  }

  protected removeField(index: any, fieldType: any) {
    fieldType.splice(index, 1);
  }
}
